export default "__VITE_ASSET__CBYWoYWx__"